import { render, staticRenderFns } from "./CardDocumentList.vue?vue&type=template&id=75df8076&scoped=true&"
import script from "./CardDocumentList.vue?vue&type=script&lang=ts&"
export * from "./CardDocumentList.vue?vue&type=script&lang=ts&"
import style0 from "./CardDocumentList.vue?vue&type=style&index=0&id=75df8076&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75df8076",
  null
  
)

export default component.exports